import { filtersToParams, SearchFiltersObject } from '@/lib/content-services/search/search'
import {
  DISQUALIFYING_FILTERS,
  buildPossiblePromotedResults,
  PromotedResultType,
  buildTermsForPromotion,
  TERMS_KEYS_TYPE
} from '@/lib/content-services/search/promotedResults'

export function getPromotedResults(filters: SearchFiltersObject): PromotedResultType[] {
  // Only show promoted results on the first page and if no disqualifying filters are applied
  if(filters.page > 1 || disqualified(filters)) return []

  // Normalize the query for matching with promotion terms
  const query = filters.query.toLowerCase()
  const TERMS_FOR_PROMOTIONS = buildTermsForPromotion(filters.stationCommonName)

  const promo = Object.keys(TERMS_FOR_PROMOTIONS).find((key: string) => {
    const termFields = TERMS_FOR_PROMOTIONS[key]
    const passed = termFields.predicates.every(predicate => predicate)
    const hasMatches = termFields.terms.some((matchWord: string) => query.includes(matchWord))

    return passed && hasMatches
  }) as TERMS_KEYS_TYPE;

  if(promo) {
    const PROMOTED_RESULTS = buildPossiblePromotedResults(filters.stationCommonName, filters.annualPassportQualifyingAmount)
    return PROMOTED_RESULTS[promo] as PromotedResultType[]
  }

  return []
}

function disqualified(filters: SearchFiltersObject) {
  const params = filtersToParams(filters)
  return DISQUALIFYING_FILTERS.some((disqualifyingFilter) => params.get(disqualifyingFilter))
}
